import { AddIcon, ChevronDownIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Divider,
  Fade,
  Flex,
  HStack,
  Icon,
  IconButton,
  Image,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Skeleton,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useDisclosure,
  useToast,
  VStack
} from '@chakra-ui/react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import exportFromJSON from 'export-from-json';
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { HiPlusCircle } from 'react-icons/hi';
import { useParams, useSearchParams } from 'react-router-dom';
import { Column } from 'react-table';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

import { PDFFileIcon } from '../../../assets/icons/PDFFile';
import { ConsentimentoButton } from '../../../components/buttons/ConsentimentoButton';
import { InteractiveTable } from '../../../components/data/InteractiveTable';
import { InteractiveTableModal } from '../../../components/data/InteractiveTableModal';
import { apiSensedia } from '../../../services/api-sensedia';
import * as CarteiraPrevidenciaService from '../../../services/previdencia-individual/carteira_previdencia.service';
import { cpf } from '../../../utils/masks';
import { BatchLgpdModal } from './components/carteira-previdencia/BatchLgpdModal';
import {
  ExtratoModal,
  ExtratoModalDTO
} from './components/carteira-previdencia/ExtratoModal';
import { SingleLgpdModal } from './components/carteira-previdencia/SingleLgpdModal';
import { WarningTextBox } from './movimentacao-fundos/components/WarningTextBox';

type Found = {
  Nome_fundo: string;
  valor: string;
};

type ConsentimentoStatus =
  | 'NOT_SENT'
  | 'SENT'
  | 'NOT_ALLOWED_BY_CLIENT'
  | 'ALLOWED_BY_CLIENT'
  | 'SYNC_WITH_MDM'
  | 'CONTACT_ERROR';

type Table = {
  NOME: string;
  CPF: string;
  NUM_PROPOSTA: string;
  COD_PRODUTO: string;
  DATA_VIGENCIA: string;
  DES_PRODUTO: string;
  DATA_NASCIMENTO: string;
  DATA_APOSENTADORIA: string;
  DIA_VENCIMENTO_COBRANCA: string;
  VLR_CONTRIB: string;
  TIPO_COBRANCA: string;
  STATUS: string;
  CODIGO_EV: string;
  CORRETOR: string;
  consentimento?: {
    cpf: string;
    consentimento: boolean;
    dataAlteracao: string;
    beneficiario: string;
    quantidadeSolicitacoes: number;
    dataSolicitacao: string;
    celular: string;
    email: string;
    status: ConsentimentoStatus;
  };
  // fundos: Found[];
};

type Data = {
  summarized: {
    saldo_total: string;
    // ev: string;
    // fundos: [
    //   {
    //     nome_fundo: string;
    //     saldo: string;
    //     participantes: [
    //       {
    //         nome: string;
    //         cpf: string;
    //         proposta: string;
    //         saldo: string;
    //       }
    //     ];
    //   }
    // ];
  };
  table: Table[] | any;
};

type Details = {
  NOME: string;
  NUM_PROPOSTA: string;
  NOME_FUNDO: string;
  PERCENTAGEM: string;
};

type FundosDetails = {
  EV: string;
  ID_FUNDO: string;
  NOME_FUNDO: string;
  SALDO_FUNDO: string;
  VALOR_REAIS: string;
  CONTA_NEGOCIO_ID: string;
};

type FundosDetailsClientes = {
  DESCRICAO: string;
  CPF: string;
  PROPOSTA: string;
  COD_PRODUTO: string;
  DES_PRODUTO: string;
};

type TableProduct = {
  row: {
    original: {
      COD_PRODUTO: string;
      DES_PRODUTO: string;
    };
  };
};

type HandleDetails = {
  row: {
    original: {
      CPF: string;
      NUM_PROPOSTA: string;
    };
  };
};

type CarteiraPrevidenciaPageProps = {
  withPagination?: boolean;
};

export const CarteiraPrevidencia = ({
  withPagination = false
}: CarteiraPrevidenciaPageProps): JSX.Element => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const {
    isOpen: isOpenAlert,
    onOpen: onOpenAlert,
    onClose: onCloseAlert
  } = useDisclosure();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2
  } = useDisclosure();

  const {
    isOpen: isOpen3,
    onOpen: onOpen3,
    onClose: onClose3
  } = useDisclosure();

  const {
    isOpen: isOpen4,
    onOpen: onOpen4,
    onClose: onClose4
  } = useDisclosure();

  const {
    isOpen: isSingleLgpdModalOpen,
    onOpen: openSingleLgpdModal,
    onClose: onSingleLgpdModalClose
  } = useDisclosure();

  const {
    isOpen: isBatchLgpdModalOpen,
    onOpen: openBatchLgpdModal,
    onClose: onBatchLgpdModalClose
  } = useDisclosure();

  const {
    isOpen: isExtratoModalOpen,
    onOpen: openExtratoModal,
    onClose: onExtratoModalClose
  } = useDisclosure();

  //Pagination
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get('page') || 1);

  useEffect(() => {
    setSearchParams(`page=${page}`);
  }, [page]);
  //const page = searchParams.get('page') || 1;

  const [extratoData, setExtratoData] = useState<ExtratoModalDTO>();

  const [dataListFilterFields, setDataListFilterFields] = useState({
    cpf: '',
    nome: '',
    produto: '',
    status: ''
  });

  //Query lista paginação
  const {
    isLoading: isLoadingList,
    isFetching: isFetchingList,
    data: listData,
    refetch: refetchDataList
  } = useQuery<Table[]>(
    ['carteira-previdencia-list', page, dataListFilterFields],
    () =>
      CarteiraPrevidenciaService.getDataWithPolling(
        Number(page),
        dataListFilterFields
      ),
    {
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5,
      retry: (failureCount: number, error: any) => {
        return (
          error?.message !== 'CARTEIRA_PREVIDENCIA_POLLING_TIMEOUT' &&
          failureCount < 3
        );
      },
      retryDelay: 3000,
      refetchOnWindowFocus: false,
      onError: (error: any) => {
        toast({
          status: 'error',
          title: 'Ops! Ocorreu um erro na consulta',
          description:
            error?.message === 'CARTEIRA_PREVIDENCIA_POLLING_TIMEOUT'
              ? 'A consulta ainda está sendo processada. Aguarde alguns instantes e tente novamente.'
              : 'Tente novamente mais tarde!',
          isClosable: true
        });
      },
      onSuccess: (data) => {
        //
      }
    }
  );

  //Logicas consentimento
  const [singleConsentRequestData, setSingleConsentRequestData] =
    useState<{ cpf: string; email?: string; celular?: string }>();

  const handleSuccessRequest = ({ cpf }: { cpf?: string }) => {
    setTable((prev: any) => {
      return prev.map((item: Table) => ({
        ...item,
        consentimento: {
          ...item.consentimento,
          status: item.CPF === String(cpf) ? 'SENT' : item.consentimento?.status
        }
      }));
    });
  };

  const handleBatchSuccessRequest = () => {
    setTable((prev: any) => {
      return prev.map((item: Table) => ({
        ...item,
        consentimento: {
          ...item.consentimento,
          status: 'SENT'
        }
      }));
    });
  };

  //Logicas Extrato
  const handleExtrato = (data: ExtratoModalDTO) => {
    setExtratoData(data);
    openExtratoModal();
  };
  /* 

  const { isLoading: isLoadingConsentimento, refetch: refetchConsentimento } =
    useQuery(
      ['carteira-previdencia-consentimentos'], //ids para esta query
      () => CarteiraPrevidenciaService.getConsents(),
      {
        keepPreviousData: true,
        refetchOnWindowFocus: false,

        onError: (err) => {
          console.log('erro consentimento:', err);
        },
        onSuccess: (data: any) => {
          if (listData) {
            const newData = listData.map((el) => {
              const foundConsentimento = data.find(
                (x: any) => x.cpf === el['CPF']
              );

              return {
                ...el,
                consentimento: {
                  ...foundConsentimento
                }
              };
            });

            setTable(newData);
          }
        }
      }
    ); */

  useEffect(() => {
    if (listData) {
      setTable(listData);

      //Enquanto existir consentimentos em sync com o mdm, a aplicação
      //irá fazer fetch novamente a cada 2 segundos
      /* if (!listData?.some((e) => e.consentimento?.status === 'NOT_SENT'))
        return; */

      const timeout = setTimeout(() => {
        const hasSomeConsentInSync = listData?.some(
          (el) => el.consentimento?.status === 'SYNC_WITH_MDM'
        );
        if (hasSomeConsentInSync) refetchDataList();
        else clearTimeout(timeout);
      }, 5000);
    }
  }, [listData]);

  //Count
  const { isLoading: isLoadingCount, isError: isErrorCount } = useQuery<{
    total_rows: number;
  }>(
    ['carteira-previdencia-count'],
    CarteiraPrevidenciaService.getTotalCountRegisters,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryDelay: 2000,
      onSuccess: (data) => setItemsCount(data.total_rows)
    }
  );

  const [loadingDetails, setLoadingDetails] = useState(false);
  const [loadingFundos, setLoadingFundos] = useState(false);
  const [loadingFundosClientes, setLoadingFundosClientes] = useState(false);

  const [table, setTable] = useState<Table[]>([
    {
      NOME: '',
      CPF: '',
      NUM_PROPOSTA: '',
      COD_PRODUTO: '',
      DATA_VIGENCIA: '',
      DES_PRODUTO: '',
      DATA_NASCIMENTO: '',
      DATA_APOSENTADORIA: '',
      VLR_CONTRIB: '',
      TIPO_COBRANCA: '',
      DIA_VENCIMENTO_COBRANCA: '',
      STATUS: '',
      CODIGO_EV: '',
      CORRETOR: ''
      // fundos: [
      //   {
      //     Nome_fundo: '',
      //     valor: ''
      //   }
      // ]
    }
  ]);

  const totalAvailableConsentsToRequests = table.filter(
    (item) => item.consentimento?.status !== 'NOT_SENT'
  ).length;

  //Sum
  const { data: totalSum, isLoading: isLoadingTotalSum } = useQuery<number>(
    ['carteira-previdencia-sum'],
    CarteiraPrevidenciaService.getTotalSum,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retryDelay: 2000
    }
  );

  const checkLGPD = (table: Table[]) => {
    const count = table
      .map((item) => `${item.CPF} + ${item.NUM_PROPOSTA}`)
      .filter((value, index, self) => self.indexOf(value) === index);

    return count.length;
  };

  const totalSumComputed = useMemo(() => {
    if (table.length && totalSum) {
      return checkLGPD(table) > 2 ? totalSum.toLocaleString('PT-BR') : '-';
    }
    return '-';
  }, [totalSum, table]);

  // Dados para teste de layout
  const [tableFundos, setTableFundos] = useState<FundosDetails[]>([
    {
      EV: '',
      ID_FUNDO: '',
      NOME_FUNDO: '',
      SALDO_FUNDO: '',
      VALOR_REAIS: '',
      CONTA_NEGOCIO_ID: ''
    }
  ]);
  const [tableFundosClientes, setTableFundosClientes] = useState<
    FundosDetailsClientes[]
  >([
    {
      DESCRICAO: '1',
      CPF: '1',
      PROPOSTA: 'teste teste',
      COD_PRODUTO: '123123123',
      DES_PRODUTO: 'teste 1'
    }
  ]);

  const [tableFundosClientesHeader, setTableFundosClientesHeader] =
    useState<FundosDetails>({
      EV: '',
      ID_FUNDO: '',
      NOME_FUNDO: '',
      SALDO_FUNDO: '',
      VALOR_REAIS: '',
      CONTA_NEGOCIO_ID: ''
    });
  const [details, setDetails] = useState<Details[]>([
    {
      NOME: '',
      NUM_PROPOSTA: '',
      NOME_FUNDO: '',
      PERCENTAGEM: ''
    }
  ]);

  const [itemsCount, setItemsCount] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(5);

  // const [nameFilter, setNameFilter] = useState('');
  //const [cpfFilter, setCpfFilter] = useState('');
  // const [productFilter, setProductFilter] = useState('');
  // const [statusFilter, setStatusFilter] = useState('');
  const nameInputRef = useRef() as MutableRefObject<HTMLInputElement>;
  const cpfInputRef = useRef() as MutableRefObject<any>;
  const productInputRef = useRef() as MutableRefObject<HTMLInputElement>;
  const statusSelectRef = useRef() as MutableRefObject<HTMLSelectElement>;

  const columns: Column<object>[] = [
    {
      Header: '',
      accessor: 'DETAILS',
      Cell: ({ row }: HandleDetails) => (
        <>
          <Tooltip label="Detalhes">
            <Button
              as={AddIcon}
              cursor="pointer"
              variant="ghost"
              w="2.8rem"
              onClick={() =>
                handleDetails(row.original.CPF, row.original.NUM_PROPOSTA)
              }
            />
          </Tooltip>
        </>
      )
    },
    {
      Header: 'Nome',
      accessor: 'NOME'
    },
    {
      Header: 'CPF',
      accessor: 'CPF'
    },
    {
      Header: 'Proposta',
      accessor: 'NUM_PROPOSTA'
    },
    {
      Header: 'Produto',
      accessor: 'DES_PRODUTO',
      Cell: ({ row }: TableProduct) => (
        <Text>
          {row.original.COD_PRODUTO} - {row.original.DES_PRODUTO}
        </Text>
      )
    },
    {
      Header: () => (
        <Flex gap={1} alignItems="center">
          <Text>Extrato</Text>
          <Tooltip
            placement="top"
            hasArrow
            arrowSize={15}
            arrow
            bg={'#D3DEED'}
            color="#000"
            label={
              <Text>
                Clique no ícone do <strong>PDF</strong> para fazer o download do
                seu extrato.
              </Text>
            }
          >
            <div>
              <AiOutlineInfoCircle size={18} />
            </div>
          </Tooltip>
        </Flex>
      ),
      Cell: ({ row }: any) => {
        const consentimento = row.original.consentimento as any;
        console.log('check data here', row.original);
        // const dataVigencia = row.original.DATA_VIGENCIA;
        const dataVigencia = row.original.DATA_INICIO_VIGENCIA
          ? row.original.DATA_INICIO_VIGENCIA.replace('Z', '-03:00')
          : row.original.DATA_INICIO_VIGENCIA;
        const disabled =
          consentimento?.status !== 'ALLOWED_BY_CLIENT' ||
          dataVigencia === null;

        const extratoData: ExtratoModalDTO = {
          data_vigencia: dataVigencia,
          cpf: row.original.CPF,
          proposta: row.original.NUM_PROPOSTA,
          ev: row.original.CODIGO_EV
        };

        return (
          <Tooltip
            p={2}
            placement="left-end"
            label={
              <Flex gap={2} alignItems="center">
                <svg
                  width="30"
                  height="18"
                  viewBox="0 0 21 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.86902 15.999C0.483056 16.6656 0.964115 17.5 1.73445 17.5H19.1077C19.878 17.5 20.359 16.6656 19.9731 15.999L11.2865 0.994826C10.9013 0.329541 9.94079 0.329542 9.55563 0.994827L0.86902 15.999ZM11.3684 13.7105C11.3684 14.2337 10.9443 14.6579 10.4211 14.6579C9.89784 14.6579 9.47368 14.2337 9.47368 13.7105C9.47368 13.1873 9.89784 12.7632 10.4211 12.7632C10.9443 12.7632 11.3684 13.1873 11.3684 13.7105ZM11.3684 9.92105C11.3684 10.4443 10.9443 10.8684 10.4211 10.8684C9.89784 10.8684 9.47368 10.4443 9.47368 9.92105V8.02632C9.47368 7.5031 9.89784 7.07895 10.4211 7.07895C10.9443 7.07895 11.3684 7.5031 11.3684 8.02632V9.92105Z"
                    fill="#E59401"
                  />
                </svg>
                <Text color={'#000'}>
                  Download de extrato não permitido por falta de consentimento
                  do cliente.
                </Text>
              </Flex>
            }
            isDisabled={!disabled}
            bg={'#F6E7B1'}
            lef
          >
            <Flex justifyContent={'center'}>
              <IconButton
                aria-label="Download Extrato"
                pointerEvents={disabled ? 'none' : 'all'}
                icon={
                  <PDFFileIcon variant={disabled ? 'secondary' : 'primary'} />
                }
                onClick={() => handleExtrato(extratoData)}
              />
            </Flex>
          </Tooltip>
        );
      },
      accessor: 'extrato',
      disableSortBy: true
    },
    {
      Header: 'Saldo',
      Cell: ({ row }: any) => {
        const consentimento = row.original.consentimento as any;

        const message =
          consentimento?.status === 'NOT_ALLOWED_BY_CLIENT'
            ? 'O cliente não autorizou a visualização do saldo.'
            : 'O saldo será apresentado após autorização do cliente';

        if (consentimento?.status === 'ALLOWED_BY_CLIENT') {
          const valorSaldo = Number(row.original.VALOR || '0').toLocaleString(
            'pt-BR',
            {
              style: 'currency',
              currency: 'BRL'
            }
          );

          return <Text>{valorSaldo}</Text>;
        }

        return (
          <Tooltip
            label={message}
            aria-label={message}
            p={3}
            bg="white"
            color="black"
            borderRadius="10px"
            maxW={230}
            fontWeight="light"
          >
            <Text filter="blur(0.3rem)">000.000,00</Text>
          </Tooltip>
        );
      },
      accessor: 'saldo',
      disableSortBy: true
    },
    {
      Header: () => (
        <Flex justifyContent={'space-between'} gap={3}>
          <Text>
            Solicitar <br />
            Consentimento
          </Text>
          <Button
            bg="#FA6B25"
            color="#fff"
            fontSize=".7rem"
            h="2.1rem"
            isLoading={false}
            onClick={() => openBatchLgpdModal()}
            m="0 !important"
            _hover={{
              opacity: '.9'
            }}
            disabled={
              !listData?.some((e) => e.consentimento?.status === 'NOT_SENT')
            }
          >
            Solicitar a todos
          </Button>
        </Flex>
      ),
      Cell: ({ row }: any) => {
        const consentimento = row.original.consentimento as any;
        const btnInfo = (() => {
          const variant: any = {
            NOT_SENT: 'primary',
            SENT: 'secondary',
            ALLOWED_BY_CLIENT: 'success',
            CONTACT_ERROR: 'error',
            NOT_ALLOWED_BY_CLIENT: 'error',
            SYNC_WITH_MDM: 'secondary',
            REACHED_CONSENT_REQUEST: 'warning',
            PHONE_NOT_FOUND: 'warning',
            EMAIL_NOT_FOUND: 'warning'
          };

          const text: any = {
            NOT_SENT: 'Solicitar Consentimento',
            SENT: 'Aguardando Retorno',
            ALLOWED_BY_CLIENT: 'Acesso aprovado pelo cliente',
            CONTACT_ERROR: consentimento?.message || 'Houve um erro',
            NOT_ALLOWED_BY_CLIENT: 'Negado pelo cliente',
            SYNC_WITH_MDM: 'Aguarde...',
            REACHED_CONSENT_REQUEST:
              'Número máximo de tentativas \n de solicitação atingido'
          };
          return {
            variant,
            text
          };
        })();
        const status = consentimento?.status;
        const exclamationIcon = (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="7.92802"
              cy="7.85185"
              r="7.35185"
              fill="#FFF1A8"
              stroke="black"
            />
            <path
              d="M7.3748 9.47H8.6398L8.7828 6.808V3.981H7.2428V6.808L7.3748 9.47ZM8.0128 12.165C8.5848 12.165 9.0358 11.714 9.0358 11.109C9.0358 10.482 8.5848 10.031 8.0128 10.031C7.4408 10.031 6.9788 10.482 6.9788 11.109C6.9788 11.714 7.4408 12.165 8.0128 12.165Z"
              fill="black"
            />
          </svg>
        );
        if (
          ['PHONE_NOT_FOUND', 'EMAIL_NOT_FOUND'].includes(
            consentimento?.error?.code
          )
        ) {
          return (
            <HStack gap={2}>
              <Box w={150}>
                <ConsentimentoButton disabled variant="warning">
                  <Box mr={2}>{exclamationIcon}</Box>
                  <Text textAlign={'left'}>
                    Erro no e-mail ou <br /> número do cliente
                  </Text>
                </ConsentimentoButton>
              </Box>
              <Box w={130}>
                <ConsentimentoButton
                  variant="primary"
                  onClick={() => {
                    setSingleConsentRequestData({
                      cpf: row.original['CPF'],
                      celular: consentimento?.['numeroCelular'],
                      email: consentimento?.['destinatario']
                    });
                    openSingleLgpdModal();
                  }}
                >
                  {'Tentar novamente'}
                </ConsentimentoButton>
              </Box>
            </HStack>
          );
        }

        const disabled =
          ![
            'NOT_SENT',
            'REACHED_CONSENT_REQUEST',
            'NOT_ALLOWED_BY_CLIENT',
            'SENT'
          ].includes(status) ||
          (today >= dataInicio && today <= dataFim);

        const resend = !['NOT_ALLOWED_BY_CLIENT', 'SENT'].includes(status);

        const isLoading = status === 'SYNC_WITH_MDM';

        // const statusProposta: string = row.original['STATUS'];

        const children =
          status === 'REACHED_CONSENT_REQUEST' ? (
            <>
              <Box mr={2}>{exclamationIcon}</Box>
              <Text textAlign={'left'}>
                {btnInfo.text[consentimento?.['status']]}
              </Text>
            </>
          ) : (
            btnInfo.text[consentimento?.['status']] || 'Solicitar Consentimento'
          );

        // if (statusProposta.toUpperCase() === 'ATIVA') {
        return (
          <Tooltip
            placement="top"
            hasArrow
            arrowSize={15}
            arrow
            bg={'#D3DEED'}
            display={resend ? 'none' : undefined}
            color="#000"
            label={<Text>Clique para reenviar</Text>}
          >
            <Skeleton isLoaded={!!consentimento} fadeDuration={1}>
              <ConsentimentoButton
                variant={
                  btnInfo.variant[consentimento?.['status']] || 'primary'
                }
                disabled={disabled}
                onClick={() => {
                  if (status === 'REACHED_CONSENT_REQUEST') {
                    const dtAlteracao = new Date(
                      consentimento.dataAlteracao._seconds * 1000 +
                        consentimento.dataAlteracao._nanoseconds / 1000000
                    );

                    dtAlteracao.setDate(dtAlteracao.getDate() + 30);
                    const formattedDate = new Intl.DateTimeFormat(
                      'pt-BR'
                    ).format(dtAlteracao);

                    toast({
                      title: 'Limite de pedidos atingido.',
                      description:
                        'Você poderá fazer um novo pedido a partir de ' +
                        formattedDate,
                      status: 'warning',
                      duration: 9000,
                      isClosable: true
                    });
                    return;
                  }

                  setSingleConsentRequestData({
                    cpf: row.original['CPF'],
                    celular: consentimento?.['numeroCelular'],
                    email: consentimento?.['destinatario']
                  });
                  openSingleLgpdModal();
                }}
                loading={isLoading}
              >
                {children}
              </ConsentimentoButton>
            </Skeleton>
          </Tooltip>
        );
        // } else {
        //   return <></>;
        // }
      },

      disableSortBy: true,
      accessor: 'consentimento'
    },
    {
      Header: 'Data nascimento',
      accessor: 'DATA_NASCIMENTO'
    },
    {
      Header: 'Data aposentadoria',
      accessor: 'DATA_APOSENTADORIA'
    },
    {
      Header: 'Dia da cobrança',
      accessor: 'DIA_VENCIMENTO_COBRANCA'
    },
    {
      Header: 'Valor contribuição',
      accessor: 'VLR_CONTRIB',
      Cell: ({ row }: { row: { original: { VLR_CONTRIB: string } } }) => (
        <Text>
          R$ {parseFloat(row.original.VLR_CONTRIB).toLocaleString('PT-BR')}
        </Text>
      )
    },
    {
      Header: 'Status',
      accessor: 'STATUS'
    }
  ];

  const columnsFundos: Column<object>[] = [
    {
      Header: 'Total',
      accessor: 'TOTAL',
      disableSortBy: true
    },
    {
      Header: 'Fundos',
      accessor: 'NOME_FUNDO',
      Cell: ({
        row
      }: {
        row: { original: { NOME_FUNDO: string; SALDO_FUNDO: string } };
      }) => {
        return (
          <Text>
            {row.original.NOME_FUNDO}: R${' '}
            {parseFloat(row.original.SALDO_FUNDO).toLocaleString('PT-BR')}
          </Text>
        );
      }
    },
    {
      Header: '',
      accessor: 'CLIENTES',
      disableSortBy: true,
      Cell: ({ row }: { row: { original: { VALOR_REAIS: string } } }) => {
        return (
          <Button
            fontSize=".7rem"
            fontWeight="semibold"
            bg="#1C375C"
            color="#fff"
            colorScheme="blue"
            height="2rem"
            onClick={() => {
              handleFundosProdutosClientes(
                tableFundos[0].NOME_FUNDO,
                tableFundos[0].SALDO_FUNDO,
                tableFundos[0].EV,
                tableFundos[0].ID_FUNDO
              );
            }}
          >
            Ver Clientes
          </Button>
        );
      }
    }
  ];

  const handleFilter = () => {
    const nameFilter = nameInputRef.current.value;
    const cpfFilter = cpfInputRef.current.inputElement.value.replace(
      /[^\d]/g,
      ''
    );
    const productFilter = productInputRef.current.value;
    const statusFilter = statusSelectRef.current.value;

    if (cpfFilter.length > 0 && cpfFilter.length < 11) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });
      return;
    }

    setDataListFilterFields({
      nome: nameFilter,
      cpf: cpfFilter,
      produto: productFilter,
      status: statusFilter
    });
  };

  useEffect(() => {
    refetchDataList();
    setPage(1);
    //setItemsCount(1);
  }, [dataListFilterFields]);

  /* const handleFilter = async () => {
    const nameFilter = nameInputRef.current.value;
    const productFilter = productInputRef.current.value;
    const statusFilter = statusSelectRef.current.value;

    console.log({
      nameFilter,
      cpfFilter,
      productFilter,
      statusFilter
    });

    //setLoadingTable(true);

    if (cpfFilter.length > 0 && cpfFilter.length < 11) {
      toast({
        position: 'top',
        description: 'CPF incompleto, favor verificar o preenchimento',
        status: 'warning',
        duration: 9000,
        isClosable: true
      });

      //setLoadingTable(false);

      return;
    }

    await getData();

    if (cpfFilter.length > 0) {
      const newTable = data.table.filter((item: { CPF: string | string[] }) =>
        item.CPF.includes(cpfFilter.replaceAll('.', '').replace('-', ''))
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (nameFilter.length > 0) {
      const newTable = data.table.filter((item: { NOME: string }) =>
        item.NOME.toLowerCase().includes(
          nameFilter.toLowerCase().replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (productFilter.length > 0) {
      const newTable = data.table.filter(
        (item: {
          COD_PRODUTO: { toString: () => string };
          DES_PRODUTO: { toString: () => string };
        }) => {
          return (
            item.COD_PRODUTO.toString()
              .toLowerCase()
              .includes(productFilter.toLowerCase().replaceAll(/\s/g, '')) ||
            item.DES_PRODUTO.toString()
              .toLowerCase()
              .includes(productFilter.toLowerCase().replaceAll(/\s/g, ''))
          );
        }
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    if (statusFilter.length > 0) {
      const newTable = data.table.filter((item: { STATUS: string }) =>
        item.STATUS.toLowerCase().includes(
          statusFilter.toLowerCase().replaceAll(/\s/g, '')
        )
      );

      setTable(newTable);
      setItemsCount(newTable.length > 10 ? 10 : newTable.length);
    }

    setLoadingTable(false);
  }; */

  const handleModals = async () => {
    onClose4();
    onOpen3();
  };

  const handleClearFilters = async () => {
    nameInputRef.current.value = '';
    cpfInputRef.current.inputElement.value = '';
    productInputRef.current.value = '';
    statusSelectRef.current.value = '';
    setDataListFilterFields({
      cpf: '',
      nome: '',
      produto: '',
      status: ''
    });
    //setLoading(true);
    /* setNameFilter('');
    setCpfFilter('');
    setProductFilter('');
    setStatusFilter(''); */
    //await getData();
    //setLoading(false);
  };

  const handleDetails = async (cpf: string, proposta: string) => {
    try {
      setLoadingDetails(true);

      onOpen();

      const response = await apiSensedia.get(
        `/gestao-de-carteiras/carteira-previdencia-individual`,
        {
          headers: { cpf: cpf },
          params: { proposta },
          timeout: 0
        }
      );

      if (response.data.data && response.data.data.length > 0) {
        setDetails(response.data.data);

        setLoadingDetails(false);
      } else {
        onClose();
        toast({
          position: 'top',
          description: 'Não foram encontrados dados para esta proposta.',
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        onClose();
        onOpen2();
      } else {
        const errorObj = error?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || error?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? error.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (error?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(error?.response?.data?.message || errorObj?.message) && (
                  <>{error.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      onClose();

      //setLoading(false);
    }
  };

  const handleFundosProdutos = async () => {
    try {
      onOpen3();
      setLoadingFundos(true);

      const response = await apiSensedia.get(
        `/gestao-de-carteiras/carteira-previdencia-individual/fundo-produtos`,
        {
          timeout: 0
        }
      );

      if (response.data.data) {
        setTableFundos(response.data.data);

        setLoadingFundos(false);
      } else {
        onClose3();
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        onClose3();
        onOpen();
      } else {
        const errorObj = error?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || error?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? error.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (error?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(error?.response?.data?.message || errorObj?.message) && (
                  <>{error.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      onClose3();

      setLoadingFundos(false);
    }
  };
  const handleFundosProdutosClientes = async (
    NOME_FUNDO: string,
    SALDO_FUNDO: string,
    EV: string,
    ID_FUNDO: string
  ) => {
    try {
      setTableFundosClientesHeader({
        NOME_FUNDO,
        SALDO_FUNDO,
        EV,
        ID_FUNDO,
        VALOR_REAIS: '',
        CONTA_NEGOCIO_ID: ''
      });

      onOpen4();
      onClose3();
      setLoadingFundosClientes(true);

      const response = await apiSensedia.get(
        `/gestao-de-carteiras/carteira-previdencia-individual/clientes-fundo?fundo=${ID_FUNDO}`,
        {
          timeout: 0
        }
      );

      if (response.data.data) {
        setTableFundosClientes(response.data.data);

        setLoadingFundosClientes(false);
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        onClose3();
        onOpen();
      } else {
        const errorObj = error?.toJSON();
        toast({
          position: 'top',
          description: (
            <Box>
              <Text>
                {' '}
                Ocorreu um erro. Esvazie o cache do navegador, aguarde alguns
                minutos e tente fazer login novamente, se persistir, por favor
                entrar em contato.
              </Text>
              <Text>
                {errorObj?.status && (
                  <>
                    <br />
                    <b>Detalhes:</b>
                    <br />
                  </>
                )}
                {(errorObj?.status || error?.response?.data?.statusCode) && (
                  <>{errorObj.status ?? error.response.data.statusCode}</>
                )}
                {errorObj?.status &&
                  (error?.response?.data?.message || errorObj?.message) &&
                  ' - '}
                {(error?.response?.data?.message || errorObj?.message) && (
                  <>{error.response.data.message ?? errorObj.message}</>
                )}
              </Text>
            </Box>
          ),
          duration: 15000,
          isClosable: true,
          status: 'error'
        });
      }

      onClose3();

      setLoadingFundosClientes(false);
    }
  };

  /* const getData = async () => {
    const requestUrl = `/estruturas-vendas/carteira-previdencia?token=${token}`;
    setLoading(true);

    try {
      const response = await apiSensedia.get(requestUrl, { timeout: 0 });

      const howManyDistinct = await checkLGPD(response.data.data);

      if (response.data.data) {
        setData({
          table: response.data,
          summarized: {
            saldo_total:
              howManyDistinct > 2
                ? parseFloat(response.data.sum).toLocaleString('PT-BR')
                : '-'
          }
        });
        setTable(response.data.data);
      }

      setLoading(false);
    } catch (error: any) {
      console.log(error);
      if (error.response.status === 401) {
        onOpen2();
      } else {
        toast({
          position: 'top',
          description: 'Ocorreu um erro, favor tente novamente.',
          status: 'error',
          duration: 7000,
          isClosable: true
        });
      }

      setLoading(false);
    }
  }; */

  const exportData = (ext: 'csv' | 'xls') => {
    const data = formatDataEfetivado() as any;
    const fileName = `Dados ${new Date().toISOString()}`;
    const exportType = exportFromJSON.types[ext];

    exportFromJSON({ data, fileName, exportType });
  };

  const formatDataEfetivado = () => {
    return listData?.map(
      (item: {
        NOME: any;
        CPF: any;
        NUM_PROPOSTA: any;
        DES_PRODUTO: any;
        DATA_NASCIMENTO: string | number | Date;
        DATA_APOSENTADORIA: string | number | Date;
        VLR_CONTRIB: any;
        TIPO_COBRANCA: any;
        DIA_VENCIMENTO_COBRANCA: any;
        STATUS: any;
        CODIGO_EV: any;
        CORRETOR: any;
      }) => {
        return {
          'Nome do Cliente': item.NOME,
          CPF: item.CPF,
          Proposta: item.NUM_PROPOSTA,
          Produto: item.DES_PRODUTO,
          'Data de Nascimento': item?.DATA_NASCIMENTO,
          'Data de Aposentadoria': item?.DATA_APOSENTADORIA,
          'Tipo de Cobrança': item.TIPO_COBRANCA,
          'Dia da Cobrança': item.DIA_VENCIMENTO_COBRANCA,
          'Valor Contribuição': item.VLR_CONTRIB,
          Status: item.STATUS,
          EV: item.CODIGO_EV,
          Corretor: item.CORRETOR
        };
      }
    );
  };

  // useEffect(() => {
  // onOpenAlert();
  // getTotalSum();
  // getData();
  // }, []);

  /* useEffect(() => {
    setItemsCount(table.length > 10 ? 10 : table.length);
  }, [table]); */

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  });

  const today = new Date();
  const dataInicio = new Date('2023-11-01T12:00:00.000-03:00');
  const dataFim = new Date('2023-11-01T22:00:00.000-03:00');

  return (
    <Stack p="1.7vw " spacing={23}>
      <Stack spacing={7}>
        <Stack spacing={1}>
          <Link href="/corretor" w="4rem">
            <HStack spacing={0}>
              <ChevronLeftIcon />
              <Text fontSize="1rem" color="#696969" fontWeight="bold">
                Voltar
              </Text>
            </HStack>
          </Link>
          <Flex justifyContent="space-between" alignItems="center">
            <Text color="#00335E" fontWeight="bold" fontSize="1.2rem">
              Carteira Previdência
            </Text>
            <Menu>
              <MenuButton
                bg="none"
                variant="outline"
                border="1px"
                borderColor="#1B365D"
                color="#1B365D"
                fontSize="0.8rem"
                as={Button}
                rightIcon={<ChevronDownIcon />}
              >
                Exportar Dados
              </MenuButton>
              <MenuList>
                <MenuItem onClick={() => exportData('csv')}>
                  Baixar .csv
                </MenuItem>
                <MenuItem onClick={() => exportData('xls')}>
                  Baixar .xls
                </MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Stack>
        {today <= dataFim ? (
          <WarningTextBox
            full={true}
            content="Devido a migração de bases do MDM as aplicações referentes ao LGPD estarão indisponíveis no dia 01/11/2023 de 12:00 às 22:00. Isso tornará o envio de solicitações de consentimento indisponível durante esse período."
          />
        ) : (
          <></>
        )}
        <HStack
          bg="#fff"
          wrap="wrap"
          borderRadius="1rem"
          minH="4.3rem"
          spacing={39}
          justify={isWideVersion ? 'flex-start' : 'center'}
          flexDir={{ base: 'column', lg: 'row' }}
          //pointerEvents={!loading ? 'all' : 'none'}
          //opacity={!loading ? '1' : '0.4'}
        >
          <HStack
            flexDir={{ base: 'column', md: 'column', lg: 'row' }}
            m=".6rem !important"
          >
            <Text fontSize=".8rem" fontWeight="bold" color="#1B365D">
              Filtrar:
            </Text>
            <Input
              ref={nameInputRef}
              color="#1B365D"
              fontSize=".7rem"
              w="8rem"
              h="2.1rem"
              placeholder="Nome"
              // value={nameFilter}
              // onChange={(e) => {
              //   setNameFilter(e.target.value);
              // }}
            />

            <Input
              as={MaskedInput}
              ref={cpfInputRef}
              mask={cpf}
              guide={false}
              color="#1B365D"
              fontSize=".7rem"
              w="9.3rem"
              h="2.1rem"
              placeholder="CPF"
              /* value={cpfFilter}
              onChange={(e) => {
                setCpfFilter(e.target.value);
              }} */
            />
            <Input
              ref={productInputRef}
              color="#1B365D"
              fontSize=".7rem"
              w="8rem"
              h="2.1rem"
              placeholder="Produto"
              // value={productFilter}
              // onChange={(e) => {
              // setProductFilter(e.target.value);
              // }}
            />
            <Select
              ref={statusSelectRef}
              color="#1B365D"
              fontSize=".7rem"
              w="8rem"
              h="2.1rem"
              // value={statusFilter}
              // onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">Todos</option>
              <option value="AC">Aceita</option>
              <option value="AT">Ativa</option>
              <option value="CA">Cancelada</option>
              <option value="EA">Em analise</option>
              <option value="ED">Em digitação</option>
              <option value="RE">Recusada</option>
              <option value="SU">Suspenso</option>
            </Select>
          </HStack>

          <Button
            bg="#FA6B25"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            isLoading={false}
            onClick={handleFilter}
            m="0 !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Filtrar
          </Button>
          <Button
            bg="#ACACAC"
            color="#fff"
            fontSize=".7rem"
            w="5.5rem"
            h="2.1rem"
            onClick={handleClearFilters}
            m=".3rem !important"
            _hover={{
              opacity: '.9'
            }}
          >
            Limpar Filtros
          </Button>
        </HStack>
      </Stack>
      <Stack
        bg="#fff"
        color="#00335E"
        borderRadius="1rem"
        p="1.4rem 1.1rem .8rem"
      >
        {table.length ? (
          <InteractiveTable
            sort="NOME"
            columns={columns}
            data={table}
            itemsCount={itemsCount}
            withPagination={withPagination}
            onPageChange={handlePageChange}
            activePageIndex={Number(page)}
            isLoadingData={isLoadingList}
            isLoadingCountPagination={isLoadingCount}
          />
        ) : (
          <Text align="center" my="2">
            Nenhum dado encontrado
          </Text>
        )}
        <HStack
          bg="#00335E"
          color="#fff"
          spacing={{ base: '0', md: '2rem', lg: '2rem' }}
          w="100%"
          p="1.5rem 2rem"
          borderRadius="1rem"
          flexDir={{ base: 'column', md: 'row', lg: 'row' }}
          align="center"
        >
          <Box>
            <Text fontSize=".8rem" fontWeight="bold">
              Saldo Total em reserva:
            </Text>
            {isLoadingTotalSum ? (
              <Spinner />
            ) : (
              <Text fontSize="1.4rem">
                {totalSumComputed === '-' ? '' : 'R$'}
                {totalSumComputed}
              </Text>
            )}
          </Box>
          <Button
            bg="#FA6B25"
            p={{
              base: '1.2rem 6.5rem',
              md: '1.2rem 8.5rem',
              lg: '1.2rem 8.5rem'
            }}
            //isLoading={loading}
            colorScheme="orange"
            borderRadius=".5rem"
            w="13rem"
            fontWeight="bold"
            //isDisabled={data.summarized.saldo_total == ''}
            fontSize=".9rem"
            onClick={handleFundosProdutos}
          >
            Ver listagem com os Fundos
          </Button>
        </HStack>
      </Stack>
      <Flex
        w="100%"
        justify="flex-end"
        fontSize=".9rem"
        align="center"
        mt="2.1rem"
      >
        <Flex
          w={{ base: '100%', lg: '60%' }}
          justify={{ base: 'center', lg: 'space-between' }}
          flexDir={{ base: 'column', lg: 'row' }}
        >
          {!isLoadingList && withPagination === false && (
            <>
              <Flex
                align="center"
                cursor="pointer"
                justify="center"
                onClick={() => {
                  setItemsCount(
                    itemsToShow + itemsCount > table.length
                      ? table.length
                      : itemsToShow + itemsCount
                  );
                }}
              >
                <HiPlusCircle size={26} color="#00335E" />
                <Text>
                  Mais itens (exibindo {itemsCount}/{table.length})
                </Text>
              </Flex>
              <Box>
                <Select
                  border="1px solid #00335E !important"
                  borderRadius="1rem !important"
                  onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                    setItemsToShow(parseInt(e.target.value))
                  }
                >
                  <option value={5}>exibir mais 5 por vez</option>
                  <option value={10}>exibir mais 10 por vez</option>
                  <option value={20}>exibir mais 20 por vez</option>
                  <option value={40}>exibir mais 40 por vez</option>
                </Select>
              </Box>
            </>
          )}
        </Flex>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent minW="60rem" borderRadius="1rem">
          <ModalHeader color="#1C375C">Fundos</ModalHeader>
          <ModalCloseButton />

          <Divider />
          {loadingDetails ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <ModalBody>
              <TableContainer>
                <Table size="sm" variant="striped">
                  <Thead h="3.25rem">
                    <Tr>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Nome:
                      </Th>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Proposta
                      </Th>
                      <Th fontSize=".9rem" color="#1C375C" textTransform="none">
                        Fundos
                      </Th>
                      <Th
                        fontSize=".9rem"
                        color="#1C375C"
                        textTransform="none"
                        w="1rem"
                      >
                        Percentual aplicado
                      </Th>
                    </Tr>
                  </Thead>

                  <Tbody>
                    <Td>{details[0].NOME}</Td>
                    <Td>{details[0].NUM_PROPOSTA}</Td>
                    <Td>{details[0].NOME_FUNDO}</Td>
                    <Td w="1rem">{details[0].PERCENTAGEM}</Td>
                    {details.slice(1).map((row) => (
                      <Tr key={row.NOME_FUNDO + row.NUM_PROPOSTA}>
                        <Td></Td>
                        <Td></Td>
                        <Td>{row.NOME_FUNDO}</Td>
                        <Td w="1rem">{row.PERCENTAGEM}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </ModalBody>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={isOpen2} onClose={onClose2}>
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Atenção!</ModalHeader>

          <ModalBody>
            <Text>Ops, sua sessão expirou.</Text>
            <Text>
              Por favor, faça novamente o login no Portal do Corretor.
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="center">
            <Link href={process.env.REACT_APP_PORTAL_URL}>
              <Button bg="#FA6B25" color="#fff" colorScheme="orange">
                Voltar
              </Button>
            </Link>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isOpen3}
        onClose={onClose3}
        size="5xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <ModalHeader>Fundos</ModalHeader>
          <ModalCloseButton />

          <Divider />
          {loadingFundos ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <ModalBody>
              {tableFundos.length ? (
                <InteractiveTableModal
                  sort="NOME_FUNDO"
                  columns={columnsFundos}
                  data={tableFundos}
                  total={'R$ ' + totalSumComputed}
                />
              ) : (
                <Text align="center">Nenhum registro encontrado.</Text>
              )}
            </ModalBody>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isOpen4}
        onClose={onClose4}
        size="5xl"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        <ModalContent textAlign="center">
          <Box display="flex" p="0rem 0.8rem" alignItems="center">
            <Text
              fontSize="0.9rem"
              fontWeight="bold"
              color="grey"
              cursor="pointer"
              onClick={handleModals}
            >
              {'<'} Voltar
            </Text>
            <ModalHeader>Fundos</ModalHeader>
          </Box>
          <ModalCloseButton />
          <Divider />
          {loadingFundosClientes ? (
            <Flex w="100%" justify="center" align="center" h="10rem">
              <Spinner />
            </Flex>
          ) : (
            <>
              <Box
                display="flex"
                justifyContent="left"
                background="#1C375C"
                color="#fff"
                fontSize="1.5rem"
                width="100%"
              >
                <Text p="0.8rem">
                  {tableFundosClientesHeader.NOME_FUNDO}:{' '}
                  {+tableFundosClientesHeader.SALDO_FUNDO > 0
                    ? 'R$' +
                      parseFloat(
                        tableFundosClientesHeader.SALDO_FUNDO
                      ).toLocaleString('PT-BR')
                    : '-'}
                </Text>
              </Box>
              <ModalBody>
                <TableContainer>
                  <Table size="sm" variant="striped" maxHeight="60vh">
                    <Thead h="3.25rem">
                      <Tr>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Participante
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          CPF
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Nº da proposta
                        </Th>
                        <Th
                          fontSize=".9rem"
                          color="#1C375C"
                          textTransform="none"
                        >
                          Produto
                        </Th>
                      </Tr>
                    </Thead>

                    <Tbody>
                      {tableFundosClientes.map((row, i) => (
                        <Tr key={i}>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.DESCRICAO}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.CPF}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.PROPOSTA}
                          </Td>
                          <Td
                            wordBreak="break-all"
                            fontSize="1rem"
                            color="#1C375C"
                            textTransform="none"
                          >
                            {row.DES_PRODUTO}
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </TableContainer>
              </ModalBody>
            </>
          )}
          <Divider mt="1rem" />
          <ModalFooter justifyContent="center"></ModalFooter>
        </ModalContent>
      </Modal>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpenAlert}
        onClose={onCloseAlert}
      >
        <ModalOverlay />
        <ModalContent textAlign="center" h="10rem">
          <ModalHeader>Atenção!</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Essa funcionalidade está passando por manutenção.</Text>
            <Text>
              Por favor, continue utilizando o restante dos serviços até que
              seja normalizado. Obrigado!
            </Text>
          </ModalBody>
        </ModalContent>
      </Modal>
      <SingleLgpdModal
        isOpen={isSingleLgpdModalOpen}
        onClose={onSingleLgpdModalClose}
        data={singleConsentRequestData}
        onSuccessRequest={handleSuccessRequest}
      />
      <BatchLgpdModal
        isOpen={isBatchLgpdModalOpen}
        onClose={onBatchLgpdModalClose}
        onSuccessRequest={handleBatchSuccessRequest}
      />
      <ExtratoModal
        data={extratoData}
        isOpen={isExtratoModalOpen}
        onClose={onExtratoModalClose}
      />
    </Stack>
  );
};
